
             <div class="itemDeft" id="{{'id-'+coursItem.Id}}">
                <div class="letter d-none d-lg-block">{{coursItem.Nom | slice:0:1}}</div>       
                <h6 class="mr-2 mb-0">
                    {{coursItem.Nom}}
                </h6>
                <p class="text-muted nomDef text-left">{{coursItem.Def}}</p> 
 
    </div>